if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        const copyBtn = this.mainDetailsToggle.querySelector('.share-button__copy');
        if (copyBtn) copyBtn.addEventListener('click', (e) => { e.preventDefault(); this.copyToClipboard(); });
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', (e) => {
          if (this.mainDetailsToggle.open) this.copyToClipboard();
        });
      }
    }

    toggleDetails() {
      if (this.mainDetailsToggle.open) {
        this.copyToClipboard();
      } else {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      const url = this.elements.urlInput ? this.elements.urlInput.value : this.urlToShare;
      const successMessage = (window.accessibilityStrings && window.accessibilityStrings.shareSuccess) || 'Lien copié dans le presse-papiers';

      const showSuccess = () => {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = successMessage;
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(showSuccess).catch(() => {
          this.fallbackCopy(url, showSuccess);
        });
      } else {
        this.fallbackCopy(url, showSuccess);
      }
    }

    fallbackCopy(text, onSuccess) {
      try {
        let success = false;
        if (text) {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.left = '-9999px';
          textarea.style.top = '0';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          success = document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        if (!success && this.elements.urlInput) {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.style.position = 'fixed';
          textarea.style.left = '-9999px';
          textarea.style.top = '0';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          success = document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        if (success && onSuccess) onSuccess();
      } catch (err) {
        if (onSuccess) onSuccess();
      }
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
